import React from 'react';
import withIcon from '../utilities/withIcon';

const IconUser = () => {
  return (
    <g>
      <path d="m8 9.0117a3.3467 3.3467 0 0 0 2.8086-1.7031 5.789 5.789 0 0 0 .53-5.1592 3.6049 3.6049 0 0 0 -3.3386-2.0937 3.605 3.605 0 0 0 -3.3389 2.0937 5.789 5.789 0 0 0 .53 5.1592 3.3468 3.3468 0 0 0 2.8089 1.7031zm-1.9736-6.2412a2.0942 2.0942 0 0 1 1.9736-1.2148 2.0942 2.0942 0 0 1 1.9736 1.2148 4.3225 4.3225 0 0 1 -.4268 3.7256 1.9264 1.9264 0 0 1 -1.5468 1.0156 1.9265 1.9265 0 0 1 -1.5469-1.0156 4.3225 4.3225 0 0 1 -.4267-3.7256z" />
      <path d="m13.1025 10.1055a7.1174 7.1174 0 0 1 -2.3135-1.1514.7514.7514 0 0 0 -1.0723.1621l-1.7167 2.4424-1.7168-2.4424a.7514.7514 0 0 0 -1.0723-.1621 7.1174 7.1174 0 0 1 -2.3135 1.1514c-1.7734.5938-2.86 1.1572-2.86 5.0889a.75.75 0 0 0 .75.75h14.4255a.75.75 0 0 0 .75-.75c0-3.9317-1.0869-4.4952-2.8604-5.0889zm-11.5525 4.3388c.0889-2.3359.6406-2.5205 1.8232-2.916a9.2307 9.2307 0 0 0 2.1121-.9383l1.9014 2.7041a.7787.7787 0 0 0 1.2266 0l1.9013-2.7041a9.2314 9.2314 0 0 0 2.1123.9385c1.1826.3955 1.7344.58 1.8232 2.916z" />
    </g>
  );
};

export default withIcon(IconUser);
